/* Recently viewed products slider. Moved from an inline script in sections/recently-viewed.liquid; loaded with defer.
   Liquid values come from the script tag: data-section-id, data-collections-url. */
var RV_SECTION_ID = document.currentScript.dataset.sectionId;
var RV_COLLECTIONS_URL = document.currentScript.dataset.collectionsUrl;
  (function () {
    'use strict';

    // Configuration
    const STORAGE_KEY = 'recently_viewed_products';
    const SWATCH_CACHE_KEY = 'recently_viewed_swatch_data::' + themeRootPath();
    const MAX_PRODUCTS = 8;

    // Get products from localStorage with validation
    function getProducts() {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        const products = stored ? JSON.parse(stored) : [];
        const validProducts = products.filter(item =>
          typeof item === 'string' && !/^\d+$/.test(item) && item.length > 0
        );

        if (validProducts.length !== products.length) {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(validProducts));
        }

        return validProducts;
      } catch (e) {
        return [];
      }
    }

    // Real swatch colour/image data can only be read from Liquid (product.js
    // has no swatch info), so we capture it straight off the DOM whenever the
    // person is actually on a product page, keyed by handle.
    function getSwatchCache() {
      try {
        const stored = localStorage.getItem(SWATCH_CACHE_KEY);
        return stored ? JSON.parse(stored) : {};
      } catch (e) {
        return {};
      }
    }

    function cacheSwatchDataForCurrentProduct(handle) {
      if (!handle) return;
      const swatchButtons = document.querySelectorAll('.pinfo .swatch-group .color-swatch');
      if (!swatchButtons.length) return;

      const map = {};
      swatchButtons.forEach(function (btn) {
        const value = btn.dataset.value;
        if (!value) return;
        map[value] = {
          color: btn.dataset.metafieldColor || null,
          image: btn.dataset.swatchImage || null
        };
      });

      try {
        const cache = getSwatchCache();
        cache[handle] = map;
        // Keep the cache from growing forever alongside the 8-product cap
        const keep = getProducts().concat([handle]);
        Object.keys(cache).forEach(function (key) {
          if (keep.indexOf(key) === -1) delete cache[key];
        });
        localStorage.setItem(SWATCH_CACHE_KEY, JSON.stringify(cache));
      } catch (e) {}
    }

    // Add product to recently viewed
    function addProduct(handle) {
      if (!handle) return;

      let recentProducts = getProducts().filter(x => x !== handle);
      recentProducts.unshift(handle);

      if (recentProducts.length > MAX_PRODUCTS) {
        recentProducts = recentProducts.slice(0, MAX_PRODUCTS);
      }

      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(recentProducts));
      } catch (e) { }
    }

    // Format price for display
    function formatPrice(price) {
      return price ? `£${(price / 100).toFixed(2)}` : '£0.00';
    }

    // Create product card element
    function createCard(product) {
      const cardElement = document.createElement('div');
      cardElement.className = 'product-card';
      cardElement.setAttribute('data-product-id', product.id);

      const variant = product.variants?.[0] || {
        id: 'default',
        price: product.price || 0,
        compare_at_price: product.compare_at_price,
        available: true,
        featured_image: product.featured_image
      };

      // Find color option index
      function findColorIndex() {
        const checkOptions = options => {
          for (let i = 0; i < options.length; i++) {
            const name = typeof options[i] === 'string' ? options[i] : options[i]?.name || options[i];
            if (/colou?r|لون/i.test(name || '')) return i + 1;
          }
          return 0;
        };

        return checkOptions(product.options || []) ||
          checkOptions(product.option_names || []) ||
          detectColorOption();
      }

      // Detect color option by analyzing variants
      function detectColorOption() {
        if (!product.variants || product.variants.length <= 1) return 0;

        const colorKeywords = ['red', 'blue', 'green', 'black', 'white', 'yellow',
          'pink', 'purple', 'orange', 'brown', 'gray', 'grey'];
        const optionSets = [new Set(), new Set(), new Set()];

        product.variants.forEach(variant => {
          if (variant.option1) optionSets[0].add(variant.option1);
          if (variant.option2) optionSets[1].add(variant.option2);
          if (variant.option3) optionSets[2].add(variant.option3);
        });

        for (let i = 0; i < optionSets.length; i++) {
          if (optionSets[i].size > 1 &&
            Array.from(optionSets[i]).some(val =>
              colorKeywords.some(color => val.toLowerCase().includes(color))
            )) {
            return i + 1;
          }
        }

        return 0;
      }

      const colorIndex = findColorIndex();
      // Generate color swatches
      function generateSwatches() {
        if (!colorIndex || !product.variants?.length) return '<div class="color-navigation color-navigation--placeholder" style="min-height: 24px;" aria-hidden="true"></div>';

        const processedColors = new Set();
        let swatchesHTML = '<div class="color-navigation">';

        product.variants.forEach(variantItem => {
          const colorValue = variantItem[`option${colorIndex}`];
          if (!colorValue || processedColors.has(colorValue)) return;

          processedColors.add(colorValue);
          const activeClass = variantItem.id === variant.id ? 'active' : '';
          const cachedSwatch = (getSwatchCache()[product.handle] || {})[colorValue] || null;

          // Get variant image
          let variantImageSrc = '';
          if (variantItem.featured_image) {
            variantImageSrc = typeof variantItem.featured_image === 'string' ?
              variantItem.featured_image : variantItem.featured_image.src;
          } else if (product.featured_image) {
            variantImageSrc = typeof product.featured_image === 'string' ?
              product.featured_image : product.featured_image.src;
          }

          // Format image URL
          if (variantImageSrc && typeof variantImageSrc === 'string') {
            if (!variantImageSrc.includes('_400x400') && !variantImageSrc.includes('?')) {
              variantImageSrc = variantImageSrc.replace(/\.(jpg|jpeg|png|gif|webp)$/i, '_400x400.$1');
            }
            if (!variantImageSrc.startsWith('http')) {
              variantImageSrc = variantImageSrc.startsWith('//') ?
                'https:' + variantImageSrc :
                'https://' + variantImageSrc.replace(/^\//, '');
            }
          }

          swatchesHTML += `<div class="scolor-box">
          <button type="button" class="color-swatch ${activeClass}"
                  data-variant-id="${variantItem.id}"
                  data-variant-price="${formatPrice(variantItem.price)}"
                  data-variant-compare-price="${variantItem.compare_at_price ? formatPrice(variantItem.compare_at_price) : ''}"
                  data-variant-available="${variantItem.available}"
                  data-variant-image="${variantImageSrc}"
                  data-color-name="${colorValue}"
                  ${cachedSwatch && cachedSwatch.image ? `data-swatch-image="${cachedSwatch.image}"` : ''}
                  ${cachedSwatch && !cachedSwatch.image && cachedSwatch.color ? `data-metafield-color="${cachedSwatch.color}"` : ''}
                  title="${colorValue}">
            <span class="sr-only">${colorValue}</span>
          </button>
        </div>`;
        });

        return swatchesHTML + '</div>';
      }

      const swatchesHTML = generateSwatches();
      // Get main product image
      let mainImageSrc = '';
      if (variant.featured_image) {
        mainImageSrc = typeof variant.featured_image === 'string' ?
          variant.featured_image : variant.featured_image.src;
      } else if (product.featured_image) {
        mainImageSrc = typeof product.featured_image === 'string' ?
          product.featured_image : product.featured_image.src;
      } else if (product.images && product.images.length > 0) {
        mainImageSrc = typeof product.images[0] === 'string' ?
          product.images[0] : product.images[0].src;
      }

      // Format main image URL
      if (mainImageSrc && typeof mainImageSrc === 'string') {
        if (!mainImageSrc.includes('_400x400') && !mainImageSrc.includes('?')) {
          mainImageSrc = mainImageSrc.replace(/\.(jpg|jpeg|png|gif|webp)$/i, '_400x400.$1');
        }
        if (!mainImageSrc.startsWith('http')) {
          mainImageSrc = mainImageSrc.startsWith('//') ?
            'https:' + mainImageSrc :
            'https://' + mainImageSrc.replace(/^\//, '');
        }
      }

      // Build card HTML
      cardElement.innerHTML = `
      <div class="product-card-wrap">
        <div class="product-image-wrapper">
          ${mainImageSrc ?
          `<img src="${mainImageSrc}" alt="${product.title}" class="product-image" data-product-image loading="lazy">` :
          `<div class="product-image-placeholder"><span>${TS('noImage', 'No Image')}</span></div>`
        }
        </div>
        ${swatchesHTML}
        <div class="pro-content">
          
          <h3 class="product-title">
            <a href="${themeRootPath()}products/${product.handle}">${product.title}</a>
          </h3>
          <div class="product-pricing">
            ${TS('from', 'From')} <span class="price-current" data-price-display>${formatPrice(variant.price)}</span><span class="vat-note">${TS('incVat', 'inc. VAT')}</span>
            <span class="price-original" style="${variant.compare_at_price > variant.price ? '' : 'display:none'}">${variant.compare_at_price > variant.price ? formatPrice(variant.compare_at_price) : ''}</span>
          </div>
          <div class="stock-status" data-stock-display>
            <span class="${variant.available ? 'in-stock' : 'out-of-stock'}">
              ${variant.available ? TS('inStock', 'In Stock') : TS('outOfStock', 'Out of Stock')}
            </span>
          </div>
          <a href="${themeRootPath()}products/${product.handle}" class="common-btn">${TS('viewMore', 'View More')}</a>
        </div>
      </div>`;

      // Apply color backgrounds and bind swatch interactions via global helper
      if (window.ColorSwatches && typeof window.ColorSwatches.init === 'function') {
        window.ColorSwatches.init(cardElement);
      }
      return cardElement;
    }
    // Load products from localStorage and fetch their data
    function loadProducts() {
      const handles = getProducts();
      const section = document.getElementById('recently-viewed-' + RV_SECTION_ID);
      const container = document.getElementById('recently-viewed-products');

      if (handles.length === 0) {
        if (container) {
          container.innerHTML = '<div class="no-products text-center"><p>' + TS('noRecentlyViewed', 'No Recently viewed items yet. Visit some product pages to see them here!') + '</p>\n<a href="' + RV_COLLECTIONS_URL + '" class="common-btn">' + TS('viewCollections', 'View Collections') + '</a></div>';
        }
        return;
      }

      if (section) section.style.display = 'block';

      // Fetch product data for all handles
      Promise.all(
        handles.slice(0, MAX_PRODUCTS).map(handle =>
          fetch(`${themeRootPath()}products/${handle}.js`)
            .then(response => response.ok ? response.json() : null)
            .catch(() => null)
        )
      ).then(products => {
        const validProducts = products.filter(Boolean);
        if (validProducts.length > 0) {
          renderProducts(validProducts);
        } else if (section) {
          section.style.display = 'none';
        }
      });
    }
    // Render products in the container
    function renderProducts(products) {
      const container = document.getElementById('recently-viewed-products');
      if (!container) return;

      container.innerHTML = '';
      const productsToShow = products.slice(0, MAX_PRODUCTS);

      if (productsToShow.length === 0) {
        const section = document.getElementById('recently-viewed-' + RV_SECTION_ID);
        if (section) section.style.display = 'none';
        return;
      }

      productsToShow.forEach(product => container.appendChild(createCard(product)));

      // Initialize interactive features
      if (window.ColorSwatches && typeof window.ColorSwatches.init === 'function') {
        window.ColorSwatches.init(document.getElementById('recently-viewed-' + RV_SECTION_ID));
      }
      initializeSlider();
      initializeColorSliders();
    }
    // Initialize color swatch functionality
    function initializeSwatches() {
      document.querySelectorAll('#recently-viewed-' + RV_SECTION_ID + ' .product-card').forEach(card => {
        const swatches = card.querySelectorAll('.color-swatch');
        const elements = {
          variantInput: card.querySelector('[data-variant-input]'),
          priceDisplay: card.querySelector('[data-price-display]'),
          originalPrice: card.querySelector('.price-original'),
          stockDisplay: card.querySelector('[data-stock-display]'),
          addToCart: card.querySelector('[data-add-to-cart]'),
          productImage: card.querySelector('[data-product-image]')
        };

        swatches.forEach(swatch => {
          swatch.addEventListener('click', function () {
            // Remove active class from all swatches
            swatches.forEach(s => s.classList.remove('active'));
            this.classList.add('active');

            const { variantId, variantPrice, variantComparePrice, variantAvailable, variantImage } = this.dataset;
            const isAvailable = variantAvailable === 'true';

            // Update variant input
            if (elements.variantInput) elements.variantInput.value = variantId;

            // Update price display
            if (elements.priceDisplay) elements.priceDisplay.textContent = variantPrice;

            // Update stock display
            if (elements.stockDisplay) {
              const stockSpan = elements.stockDisplay.querySelector('span');
              if (stockSpan) {
                stockSpan.className = isAvailable ? 'in-stock' : 'out-of-stock';
                stockSpan.textContent = isAvailable ? TS('inStock', 'In Stock') : TS('outOfStock', 'Out of Stock');
              }
            }

            // Update add to cart button
            if (elements.addToCart) {
              elements.addToCart.classList.toggle('disabled', !isAvailable);
              elements.addToCart.toggleAttribute('disabled', !isAvailable);
            }

            // Update product image
            if (elements.productImage && variantImage) {
              elements.productImage.src = variantImage;
            }
          });
        });
      });
    }
    // Track current product for recently viewed
    function trackProduct() {
      const productPath = window.location.pathname.match(/\/products\/([^/?]+)/);
      if (!productPath) return;

      const productHandle = document.querySelector('meta[name="product-handle"]')?.getAttribute('content') || productPath[1];
      if (productHandle) {
        addProduct(productHandle);
        cacheSwatchDataForCurrentProduct(productHandle);
      }
    }
    // Initialize main product slider
    function initializeSlider() {
      if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
        const slider = jQuery('#recently-viewed-products');

        // Destroy existing slider if initialized
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }

        // Initialize new slider
        slider.slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
      }
    }
    // Initialize color swatch sliders
    function initializeColorSliders() {
      document.querySelectorAll('#recently-viewed-' + RV_SECTION_ID + ' .color-navigation').forEach(colorNav => {
        // Destroy existing slider if initialized
        if (colorNav.classList.contains('slick-initialized')) {
          $(colorNav).slick('unslick');
        }

        const colorSwatches = colorNav.querySelectorAll('.scolor-box');

        // Only initialize slider if more than 4 colors
        if (colorSwatches.length > 4) {
          $(colorNav).slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev">‹</button>',
            nextArrow: '<button type="button" class="slick-next">›</button>',
            responsive: [
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 4,
                }
              }
            ]
          });
        }
      });
    }
    // Initialize the recently viewed items functionality
    function initialize() {
      trackProduct();
      loadProducts();
    }

    // Start when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize);
    } else {
      initialize();
    }
  })();
